import * as pdfjs from "pdfjs-dist";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const convertPdfToImage = async (pdfFile: File) => {
  try {
    if (pdfFile.type !== "application/pdf") return pdfFile;
    const pdfData = new Uint8Array(await pdfFile.arrayBuffer());
    const pdf = await pdfjs.getDocument({ data: pdfData }).promise;

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    let totalHeight = 0;
    const pageWidths: number[] = [];

    for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
      const page = await pdf.getPage(pageNumber);
      const viewport = page.getViewport({ scale: 1.0 });

      pageWidths.push(viewport.width);
      totalHeight += viewport.height;
    }

    canvas.width = Math.max(...pageWidths);
    canvas.height = totalHeight;

    if (context) {
      let currentHeight = 0;
      for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
        const page = await pdf.getPage(pageNumber);
        const viewport = page.getViewport({ scale: 1.0 });

        // Translate the context for each page
        context.translate(0, currentHeight);

        await page.render({
          canvasContext: context,
          viewport: viewport,
          canvas: canvas,
        }).promise;

        // Reset the translation for the next page
        context.translate(0, -currentHeight);

        currentHeight += viewport.height;
      }
    }

    const imageBlob: Blob | null = await new Promise(resolve => {
      canvas.toBlob(blob => resolve(blob), "image/png");
    });

    const imageName = pdfFile.name.replace(".pdf", ".png");
    const imageFile = new File(imageBlob ? [imageBlob] : [], imageName, {
      type: "image/png",
    });

    return imageFile;
  } catch (error) {
    console.error("Error converting PDF to image", error);
    return pdfFile;
  }
};
